<template>
  <view>
    <view
      class="nav-box"
      :style="{marginTop:`${height}px`}"
    >
      <view class="nav-top-one">
        <image
          :src="logo"
          class="nav-top-left"
          @click="backpage"
        />
        <view class="nav-top-center" />
        <image
          :src="logo"
          class="nav-top-right"
          @click="BackHome"
        />
      </view>
      <view class="nav-top-text">
        1111
      </view>
    </view>
  </view>
</template>

<script>
export default {
	data(){
		return{
			height:'',
			logo:require('static/logo.png')
		};
	},
	onReady() {
		this.navBar();
	},
	methods:{
		navBar(){
			uni.getSystemInfo({	
			success:(res)=>{
				this.height=res.statusBarHeight;
			}
			});
		},
		backpage(){
			
		},
		BackHome(){
			
		}
	}
};
</script>

<style lang="less" scoped>
	.nav-box {
	position:relative;
	padding-left: 16rpx;
	background:#ffffff;
	height:76rpx;
	width:100%;
	position: fixed;
	left:0;
	top:0;
	}
	.nav-top-one {
	    width: 174rpx;
	    height: 64rpx;
	    background: rgba(255, 255, 255, 0.6);
	    border-radius: 32rpx;
	    border: 1px solid rgba(0, 0, 0, 0.08);
	    box-sizing: border-box;
	    padding: 0 26rpx;
	
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	}
	
	.nav-top-left {
	    height: 36rpx;
	    width: 36rpx;
	}
	
	.nav-top-right {
	    height: 36rpx;
	    width: 36rpx;
	}
	
	.nav-top-center {
	    width: 1px;
	    height: 18px;
	    background: rgba(51, 51, 51, 1);
	    opacity: 0.2;
	}
	
	.nav-top-text {
	    position: absolute;
	    font-size: 18px;
	    font-family: PingFangSC-Medium, PingFang SC;
	    font-weight: 500;
	    color: rgba(0, 0, 0, 1);
	    height: 52rpx;
	    line-height: 52rpx;
	    left:50%;
	    top:50%;
	    transform:translate(-50%,-50%);
	    
	}
</style>
